import {Grid, SxProps, Theme, Typography} from "@mui/material";

interface FieldsTableHeaderProps {
    items: string[];
    columns?: number;
    breakpoints?: number[];
    sx?: SxProps<Theme>;
}

export const FieldsTableHeader: React.FC<FieldsTableHeaderProps> = ({items, columns, breakpoints, sx}) => {
    const defaultGridStyles: SxProps<Theme> = {
        p: 1,
        backgroundColor: "#F3F5FA",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "#E9EBF1",
    };

    return (
        <Grid
            container
            columns={columns ? columns : 12}
            sx={{
                ...defaultGridStyles,
                ...sx,
            }}
        >
            {items.map((item, index) => {
                const breakpoint = breakpoints ? breakpoints[index] : true;
                return (
                    <Grid key={index} item xs={breakpoint}>
                        <Header>{item}</Header>
                    </Grid>
                );
            })}
        </Grid>
    );
};

const Header: React.FC<{children: React.ReactNode}> = ({children}) => (
    <Typography
        textTransform="uppercase"
        sx={{
            color: "#545A6E",
        }}
        fontSize={14}
    >
        {children}
    </Typography>
);
